import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { portsOptions } from '../data-provider/ports';
import type { PortsParams } from '../models';

export const useGetPorts = (params: PortsParams) => useQuery(portsOptions(params));
export const useSuspensePorts = (params: PortsParams) => useSuspenseQuery(portsOptions(params));
